import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { supabase } from '../supabaseClient';

interface ProtectedRouteProps {
	children: React.ReactNode;
	isAdmin: boolean;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
	const [checking, setChecking] = useState(true);
	const [session, setSession] = useState<any>(null);

	useEffect(() => {
	  supabase.auth.getSession().then(({ data: { session } }) => {
	    setSession(session);
	    setChecking(false);
	  });
	}, []);

	if (checking) return null; // or a loading spinner

	if (!session) {
	  return <Navigate to="/admin" replace />;
	}

	return <>{children}</>;
};

export default ProtectedRoute;
